module.exports = __webpack_public_path__ + "img/icon-schedule.b448bb1b.png";